import Vue from 'vue'
import RatingStars from 'components/rating/rating-stars'

import withRender from './previous-ratings.html'
import './previous-ratings.scss'

export default withRender(Vue.extend({
  props: {
    /* Example structure:
      [
        {"rating": 3, "updateDateFormatted": "Dec 12 2017"},
        {"rating": 4, "updateDateFormatted": "Feb 02 2018"}
      ]
    */
    previousRatings: { type: Array }
  },
  components: {
    'tt-rating-stars': RatingStars
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/components/review/previous-ratings.ts